/** Tetapan -> Perancangan -> Sempadan bidang kuasa: muat naik fail, pemilih lapisan Pustaka, peta pratonton dan fakta. */
export default {
  boundary: 'Sempadan bidang kuasa',
  boundaryHint:
    'Poligon dalam WGS 84 (EPSG:4326) daripada fail GeoJSON atau lapisan Pustaka, sehingga 1,000,000 aksara GeoJSON. Tapak di luarnya gagal semakan.',
  boundaryUpload: 'Muat naik GeoJSON',
  boundaryRemove: 'Buang sempadan',
  boundaryNone: 'Tiada sempadan: semakan memberi amaran bahawa bidang kuasa belum dikonfigurasikan.',
  boundarySummary: '{{type}} dengan {{vertices}} bucu',
  boundaryMap: 'Peta sempadan bidang kuasa',
  boundaryArea: 'Keluasan: {{area}} km²',
  boundaryExtent: 'Liputan: longitud {{minLon}} hingga {{maxLon}}, latitud {{minLat}} hingga {{maxLat}}',
  boundaryWarnings: {
    very_small:
      'Kawasan ini sangat kecil bagi sesuatu bidang kuasa (kurang daripada 0.5 km²). Pastikan sempadan ini betul.',
    very_large:
      'Kawasan ini sangat besar bagi sesuatu bidang kuasa (melebihi 50,000 km²). Pastikan sempadan ini betul.',
  },
  boundarySource: {
    file: 'Daripada fail {{name}}',
    layerFeature: 'Daripada lapisan {{layer}}, fitur {{feature}}',
    layerAll: 'Daripada lapisan {{layer}}, semua fitur',
    noId: 'Fitur ini tiada ID, jadi ia tidak boleh dikemas kini daripada lapisan.',
  },
  boundaryRefresh: 'Kemas kini daripada lapisan',
  boundaryRefreshing: 'Mengemas kini…',
  boundaryRefreshed: 'Dikemas kini daripada lapisan. Simpan untuk mengekalkannya.',
  boundaryLayer: {
    open: 'Guna fitur daripada lapisan',
    layer: 'Lapisan poligon',
    chooseLayer: 'Pilih lapisan',
    loadingLayers: 'Memuatkan lapisan…',
    layersFailed: 'Lapisan Pustaka tidak dapat dimuatkan.',
    noLayers: 'Pustaka tiada lapisan poligon yang boleh digunakan.',
    layersCapped: 'Hanya {{limit}} lapisan Pustaka yang pertama dicari.',
    noLayersCapped: 'Tiada lapisan poligon yang boleh digunakan antara {{limit}} lapisan Pustaka yang pertama.',
    loadingFeatures: 'Memuatkan fitur…',
    featuresFailed: 'Lapisan ini tidak dapat dibaca. Cuba lagi atau pilih lapisan lain.',
    noFeatures: 'Lapisan ini tiada fitur poligon.',
    labelField: 'Atribut label',
    feature: 'Fitur',
    chooseFeature: 'Pilih fitur',
    allFeatures: 'Semua fitur dalam lapisan ini',
    unnamed: 'Fitur {{n}}',
    featuresCapped:
      'Hanya {{limit}} fitur yang pertama disenaraikan, dan "Semua fitur" menggabungkan fitur ini sahaja.',
    noIdWarning: 'Fitur ini tiada ID, jadi ia tidak boleh dikemas kini daripada lapisan kemudian.',
    use: 'Guna sempadan ini',
    cancel: 'Batal',
  },
  boundaryErrors: {
    too_large:
      'Sempadan terlalu terperinci: melebihi 1,000,000 aksara GeoJSON. Pilih fitur yang lebih kecil atau permudahkannya.',
    file_too_large: 'Fail melebihi 10 MB.',
    invalid_json: 'Fail bukan JSON yang sah.',
    no_polygon: 'Tiada poligon atau multipoligon ditemui.',
    bad_coordinates: 'Koordinat bukan longitud dan latitud dalam WGS 84.',
    fetch_failed: 'Lapisan tidak dapat dibaca. Cuba lagi kemudian.',
    feature_gone: 'Fitur ini tiada lagi dalam lapisan (hanya 1,000 fitur yang pertama dicari).',
    not_refreshable: 'Fitur ini tiada ID, jadi ia tidak boleh dikemas kini daripada lapisan.',
  },
} as const
